import Faqs from "../components/Faq";
import facebook from '../assets/icons/facebook.svg'
import instagram from '../assets/icons/instagram.svg'
import tiktok from '../assets/icons/tiktok.svg'
import youtube from '../assets/icons/youtube.svg'
import { Link } from "react-router-dom";
import { motion } from "motion/react"


const About = () => {

  const teamMembers = [
    {
      name: 'John Akano Ademola',
      title: 'CEO/MD',
      image: 'CEO.JPG',
    },
    {
      name: 'Yusuf Ademola Abdullahi',
      title: 'COO',
      image: 'Coo.JPG',
    },
    {
      name: 'Oyebola Blessing Opeyemi',
      title: 'Head of sales and marketing',
      image: 'Marketing.jpg',
    },
    {
      name: 'Nwaomucha Kenneth Ifeanyi',
      title: 'Videographer/Editor',
      image: 'Videographer.jpg',
    },
    {
      name: 'Olatunji Kehinde Babatunde',
      title: 'Customer relationship officer',
      image: 'Cro.jpg',
    },
    // Add more team members as needed
  ];

  return (
    <div className="pt-[104px]">
      <div className="relative">
        <div className="sm:h-[50vh]">
          <div className="z-10 absolute inset-0 bg-black bg-opacity-40"></div>
          <img src={require('../assets/imgs/aboutus.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
        </div>
        <div className='top-1/2 left-1/2 z-20 absolute flex flex-col m-auto px-7 w-full md:w-3/4 overflow-hidden text-white -translate-x-1/2 -translate-y-1/2'>
          <motion.h1
            initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className='font-[PlayfairDisplay] font-semibold text-[40px] md:text-[60px] text-center'>About AK-JODEM</motion.h1>
          <motion.p
            initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className='font-[PlayfairDisplay] font-medium text-[20px] md:text-[20px] text-center'>Get To Know us</motion.p>
        </div>
      </div>
      <div className="mx-auto mt-9 px-6 max-w-7xl">
        <div className="flex lg:flex-row flex-col items-center gap-[30px] md:gap-[100px] overflow-hidden">
          <motion.div
            initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="rounded-tr-[90px] rounded-bl-[90px] w-full h-[400px] overflow-hidden">
            <img src={require('../assets/imgs/about1.jpeg')} alt='hero section background' className='rounded-tr-[90px] rounded-bl-[90px] w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="flex flex-col gap-4">

            <h1 className="font-[PlayfairDisplay] font-bold text-3xl md:text-4xl">AK-JODEM</h1>
            <p className="text-lg text-justify">
              We are a dynamic, multi-sector real estate company with a strong presence across Real Estate, Agriculture, and Logistics. Our dedication to excellence, innovation, and integrity has earned us a solid reputation as a trusted leader in these sectors.
            </p>
            <p className="text-lg text-justify">Our broad range of services and in-depth industry expertise enable us to offer comprehensive, value-driven solutions tailored to meet the unique needs of our clients.
            </p>
            <p className="text-lg text-justify">With a passionate and experienced team at the core of our operations, we are committed to the success of every project we undertake. We focus on delivering quality services and sustainable impact, while supporting the development of the communities we serve.
            </p>
            <p className="text-lg text-justify">Partner with us today and discover how we can help you achieve your goals.
            </p>



            <div className="flex justify-between items-center">
              <Link to="/Contact" className="bg-white hover:bg-[#c08b53] mt-6 lg:mt-0 px-6 py-3 border border-black hover:border-none rounded-lg font-semibold hover:text-white">
                Contact Us
              </Link>
              <div className="flex gap-3">
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.facebook.com/share/1Kbi7WK22q/?mibextid=wwXIfr'><img src={facebook} alt='facebook icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.instagram.com/ak_jodem?igsh=azB3aW43cHdhMnpu'><img src={instagram} alt='instagram icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.tiktok.com/@ak.jodem?_t=ZS-8vQHBpiryCu&_r=1'><img src={tiktok} alt='tiktok icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://m.youtube.com/@Akjodem'><img src={youtube} alt='youtube icon' className="h-[15px]" /></a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>


        <section className="grid grid-cols-1 md:grid-cols-3 shadow-lg m-auto my-10">
          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8, }}
            whileInView={{ opacity: 1, scale: 1, }}
            transition={{ duration: 0.7, ease: "linear", delay: 0 }} className="col-span-1 row-span-3 rounded-l-[100px] h-full overflow-hidden">
            <img src={require('../assets/imgs/hero6.jpeg')} alt='hero section background' className='hidden md:block w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8, }}
            whileInView={{ opacity: 1, scale: 1, }}
            transition={{ duration: 0.7, ease: "linear", delay: 0 }} className="h-[320px] overflow-hidden">
            <img src={require('../assets/imgs/hero1.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
          </motion.div>
          <div className="flex-1 space-y-4 p-4">
            <h2 className="font-semibold text-2xl">Our Mission</h2>
            <p className="text-lg">
              To deliver innovative and value-driven solutions across real estate, agriculture, and logistics—making dreams a reality for individuals and businesses through exceptional service, profitable investments, and a commitment to excellence
            </p>
          </div>

          <div className="flex-1 space-y-4 p-4">
            <h2 className="font-semibold text-2xl">Our Vision</h2>
            <p className="text-lg">
              To be a leading multi-sector enterprise known for transforming lives, driving profitable investments, and making dreams a reality through excellence in real estate, agriculture, and logistics.
            </p>
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8, }}
            whileInView={{ opacity: 1, scale: 1, }}
            transition={{ duration: 0.7, ease: "linear", delay: 0 }} className="h-[320px] overflow-hidden">
            <img src={require('../assets/imgs/hero4.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
          </motion.div>
        </section>

        {/* Core Values Section */}
        <section className="space-y-4">
          <motion.h2
            initial={{ opacity: 0, scale: 0.8, translateY: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="font-semibold text-2xl text-center">Why Choose Us?</motion.h2>
          <div className="gap-4 grid md:grid-cols-3 overflow-hidden text-black">
            <motion.div
              initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
              whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="flex-1 bg-[#8f9537] p-5 rounded-lg md:text-left text-center">
              <p className="">
                At AK-JODEM, we believe in delivering value
                to our clients through our expertise and
                commitment to excellence.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8, translateY: 150 }}
              animate={{ translateY: 0 }}
              whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="flex-1 bg-[#8f9537] p-5 rounded-lg md:text-left text-center">
              <p className="">
                Our diverse range of services, combined with our
                highly experienced team, allows us to provide a
                comprehensive solution to our clients.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
              whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="flex-1 bg-[#8f9537] p-5 rounded-lg md:text-left text-center">
              <p className="">
                We take pride in our ability to understand the
                unique needs of each project and develop
                custom solutions to meet those needs.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
              whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="flex-1 bg-[#8f9537] p-5 rounded-lg md:text-left text-center">
              <p className="">
                Our focus on sustainability and responsible
                business practices set us apart in the
                industry.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
              whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="flex-1 bg-[#8f9537] p-5 rounded-lg md:text-left text-center">
              <p className="">
                We are dedicated to ensuring the
                success of each project we undertake and
                strive to exceed our client's expectations.
                Choose us for reliable, high-quality solutions and exceptional customer service.

              </p>
            </motion.div>
          </div>
        </section>

        <section className="my-10">
          <h2 className="mb-6 font-semibold text-2xl text-center">Meet Our Team</h2>
          <div className="gap-8 grid md:grid-cols-2 lg:grid-cols-4">
            {teamMembers.map((member, index) => (
              <motion.div
                initial={{ opacity: 0, scale: 0.8, translateY: 200 }}
                whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
                transition={{ duration: 0.7, ease: "easeOut", delay: Number(`0.${index}`) }}
                key={index} className="bg-white shadow-lg rounded-lg overflow-hidden">
                <img
                  className="w-full h-80 object-cover object-top"
                  src={require(`../assets/imgs/${member.image}`)}
                  alt={`${member.name}'s profile`}
                />
                <div className="p-6 text-center">
                  <h3 className="font-semibold text-gray-800 text-lg">{member.name}</h3>
                  <p className="text-gray-600 text-sm">{member.title}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        <Faqs />
      </div>
    </div>
  );
};

export default About;
